import React, { useState } from 'react';
import OnboardModal from './OnboardModal';
import { IconBriefcase } from './onboarding/OnboardingIcons';

const OnboardButton = () => {
  const [showModal, setShowModal] = useState(false);

  const handleOnboardClick = () => {
    setShowModal(true);
  };

  return (
    <>
      <button
        type="button"
        className="onboard-button"
        onClick={handleOnboardClick}
        title="Register your company as a data provider"
      >
        <IconBriefcase className="ds-btn-icon" width={18} height={18} aria-hidden />
        <span>Register as provider</span>
      </button>
      
      {showModal && (
        <OnboardModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default OnboardButton;
